export const formatExpiryDate = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 4);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
};

export const normalizeExpiryDate = (value) => {
  const trimmed = (value || '').trim();
  if (!trimmed) return '';

  if (/^\d{2}\/\d{2}$/.test(trimmed)) {
    return trimmed;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }

  return trimmed;
};
